import * as React from 'react'
import {
  Button,
  IconButton,
  Typography,
  Box,
  Paper,
  ButtonGroup,
  CircularProgress
} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { createEffect, createStore } from 'effector'
import {
  $servicePage,
  getServicePageFx
} from '../../Api/PaidService/servicePage'
import { $taskTypes, getTaskTypesFx } from '../../Api/taskTypes'
import { Link, useParams } from 'react-router-dom'
import { useStore } from 'effector-react'
import api from '../../Auth/api'
import { TASK_TYPE } from '../../common/constants'
import InitTask from './Tasks/Init'
import DocumentInfoWidget from './DocumentInfo'
import CalculationNecessityTask from './Tasks/CalculationNecessity'
import ExecutionWidget from './Tasks/Execution'
import InitialCalculationWidget from './Tasks/InitialCalculation'
import AdditionalCalculationWidget from './Tasks/AdditionalCalculation'
import InitialCalculationCheckWidget from './Tasks/InitialCalculationCheck'
import AdditionalCalculationCheckWidget from './Tasks/AdditionalCalculationCheck'
import InitialBillingWidget from './Tasks/InitialBilling'
// import WaitingPaymentWidget from './Tasks/WaitingPayment'
import AdditionalBillingWidget from './Tasks/AdditionalBilling'
import ContractPreparationWidget from './Tasks/ContractPreparation'
import ContractPaymentConfirmationWidget from './Tasks/ContractPaymentConfirmation'
import UniversalTransferDocumentWidget from './Tasks/UniversalTransferDocument'
import { MyModal } from '../../components/MyModal/MyModal'
import { CancelServiceForm } from '../../components/ServicePage/CancelServiceForm'
import { CancelCauseBlock } from '../../components/ServicePage/CancelCauseBlock'
import { ReturnToWorkForm } from '../../components/ServicePage/ReturnToWorkForm'
import { markPaidServiceAsUnreadFx } from '../../Api/PaidService/inWork'

export const $departmentTable = createStore<any>([])

export const getDepartmentTableFx = createEffect(async () =>
  api.get(`paid-service/department-list`)
)

$departmentTable.on(getDepartmentTableFx, (state) => {
  return { ...state }
})

$departmentTable.on(getDepartmentTableFx.done, (state, { result }) => {
  return {
    ...state,
    data: result.data.data
  }
})

$departmentTable.on(getDepartmentTableFx.fail, (state) => {
  return { ...state }
})

export default function ServicePage() {
  const { id } = useParams()

  const servicePage = useStore($servicePage)
  const markAsUnreadIsPending = useStore(markPaidServiceAsUnreadFx.pending)
  const serviceData = servicePage?.data
  const isActive = serviceData?.['is_active']
  const canReturnToWork = serviceData?.['is_rollback_start']

  const taskTypes = useStore($taskTypes) as {
    id: number
    name: string
    branch: string
  }[]

  const [isCanceled, setIsCanceled] = React.useState(!isActive)

  const [cancelCause, setCancelCause] = React.useState('')

  const [cancelModalisOpen, setCancelModalIsOpen] = React.useState(false)

  const [returnToWorkModalIsOpen, setReturnToWorkModalIsOpen] =
    React.useState(false)

  const tasks = serviceData?.tasks

  const onOpenCancelModal = React.useCallback(() => {
    setCancelModalIsOpen(true)
  }, [])
  const onCloseCancelModal = React.useCallback(() => {
    setCancelModalIsOpen(false)
  }, [])

  const onOpenReturnToWorkModal = React.useCallback(() => {
    setReturnToWorkModalIsOpen(true)
  }, [])
  const onCloseReturnToWorkModal = React.useCallback(() => {
    setReturnToWorkModalIsOpen(false)
  }, [])

  React.useEffect(() => {
    getTaskTypesFx()
    getDepartmentTableFx()
    getServicePageFx(Number(id))
  }, [id])

  React.useEffect(() => {
    if (isActive !== undefined) {
      if (!isActive) {
        setIsCanceled(true)
      } else {
        setIsCanceled(false)
      }
    }
  }, [isActive])

  React.useEffect(() => {
    if (isCanceled) {
      setCancelCause(serviceData?.['rollback-message'] || '')
    } else {
      setCancelCause('')
    }
  }, [isCanceled, serviceData])

  // Показываем страницу только когда в сторе данные именно этой услуги,
  // иначе виджеты смонтируются с данными предыдущей услуги
  const isCurrentServiceData = serviceData?.id === Number(id)

  return serviceData && isCurrentServiceData ? (
    <>
      <Paper
        sx={{ padding: '1rem', borderRadius: '1rem', mt: 3 }}
        elevation={0}
      >
        <Box display="flex" gap={2} alignItems="center">
          <Link to="/">
            <IconButton title="На главную">
              <ArrowBackIcon />
            </IconButton>
          </Link>
          <Typography variant="h5" fontWeight="bold" color="black">
            Услуга по входящему {serviceData?.document?.info}
          </Typography>
          {!isCanceled && (
            <Button
              variant="contained"
              color="error"
              sx={{ ml: 2 }}
              onClick={onOpenCancelModal}
            >
              Отменить
            </Button>
          )}
        
          {isCanceled && (
            <Box sx={{ display: 'flex' }}>
              <Typography variant="h6" color="error" sx={{ ml: 2 }}>
                Отменена
              </Typography>
              <Button
                variant="contained"
                color={'success'}
                sx={{ ml: 2 }}
                onClick={onOpenReturnToWorkModal}
                disabled={!canReturnToWork}
              >
                Вернуть в работу
              </Button>
            </Box>
          )}
          {serviceData?.doneAt && (
            <Typography variant="h5" fontWeight="bold" color="green">
              Закрыто {serviceData?.doneAt}
            </Typography>
          )}
        </Box>
      </Paper>
      {['main', 'universalTransferDocument', 'legalDepartment'].map(
        (branch) => (
          <Box mt={2} display="flex" flexWrap="wrap" gap={0}>
            <ButtonGroup
              variant="contained"
              aria-label="outlined primary button group"
              color="success"
              disableElevation
            >
              {taskTypes
                .filter((taskType) => taskType.branch === branch)
                .map((taskType) => (
                  <Button
                    key={taskType.id}
                    size="small"
                    sx={{ fontSize: '10px' }}
                    color={(() => {
                      if (tasks?.[branch]?.[taskType.id]?.isFinished) {
                        return 'success'
                      }
                      if (tasks?.[branch]?.[taskType.id]?.isActive) {
                        return 'primary'
                      }

                      return 'inherit'
                    })()}
                    variant="contained"
                  >
                    {taskType.name}
                  </Button>
                ))}
            </ButtonGroup>
          </Box>
        )
      )}
      <Box
        display="grid"
        gap={3}
        mt={3}
        sx={{ gridTemplateColumns: '2fr 1fr' }}
      >
        <Box display="flex" flexDirection="column" gap={3}>
          <InitTask
            task={tasks?.main[TASK_TYPE.INIT]}
            isCanceled={isCanceled}
          />

          <Box display="grid" gap={3} sx={{ gridTemplateColumns: '1fr 1fr' }}>
            <CalculationNecessityTask
              isCanceled={isCanceled}
              task={tasks?.main[TASK_TYPE.CALCULATION_NECESSITY]}
            />

            <ExecutionWidget
              isCanceled={isCanceled}
              task={tasks?.main[TASK_TYPE.EXECUTION]}
              initTask={tasks?.main[TASK_TYPE.INIT]}
            />

            <InitialCalculationWidget
              isCanceled={isCanceled}
              task={tasks?.main[TASK_TYPE.INITIAL_CALCULATION]}
            />

            <AdditionalCalculationWidget
              isCanceled={isCanceled}
              task={tasks?.main[TASK_TYPE.ADDITIONAL_CALCULATION]}
            />

            <InitialCalculationCheckWidget
              isCanceled={isCanceled}
              task={tasks?.main[TASK_TYPE.INITIAL_CALCULATION_CHECK]}
            />

            <AdditionalCalculationCheckWidget
              isCanceled={isCanceled}
              task={tasks?.main[TASK_TYPE.ADDITIONAL_CALCULATION_CHECK]}
            />

            <InitialBillingWidget
              isCanceled={isCanceled}
              task={tasks?.main[TASK_TYPE.INITIAL_BILLING]}
            />

            {/* <WaitingPaymentWidget
              isCanceled={isCanceled}
              task={tasks?.main[TASK_TYPE.WAITING_PAYMENT]}
            /> */}

            <AdditionalBillingWidget
              isCanceled={isCanceled}
              task={tasks?.main[TASK_TYPE.ADDITIONAL_BILLING]}
            />

            <div></div>

            <UniversalTransferDocumentWidget
              task={
                tasks?.universalTransferDocument[
                  TASK_TYPE.UNIVERSAL_TRANSFER_DOCUMENT
                ]
              }
              isCanceled={isCanceled}
            />

            <ContractPreparationWidget
              task={tasks?.legalDepartment[TASK_TYPE.CONTRACT_PREPARATION]}
              isCanceled={isCanceled}
            />

            <ContractPaymentConfirmationWidget
              task={
                tasks?.legalDepartment[TASK_TYPE.CONTRACT_PAYMENT_CONFIRMATION]
              }
              isCanceled={isCanceled}
            />
          </Box>
        </Box>
        <Box>
          <DocumentInfoWidget
            documentInfo={serviceData.document}
            serviceId={Number(id)}
          />
          {isCanceled && <CancelCauseBlock text={cancelCause} />}
        </Box>
      </Box>
      <MyModal
        title={'Отмена услуги'}
        open={cancelModalisOpen}
        handleClose={onCloseCancelModal}
      >
        <CancelServiceForm callback={onCloseCancelModal} />
      </MyModal>
      <MyModal
        title={'Подтвердите действие'}
        open={returnToWorkModalIsOpen}
        handleClose={onCloseReturnToWorkModal}
      >
        <ReturnToWorkForm callback={onCloseReturnToWorkModal} />
      </MyModal>
    </>
  ) : (
    <Box sx={{ display: 'flex', margin: 'auto' }}>
      <CircularProgress />
    </Box>
  )
}
